import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";
import './terms.css';

class Terms extends Component {
    render() {
        const { t } = this.props;
        let path = window.location.pathname;
        let match = path.slice(0, 3);

        return (
            <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
                <MetaTags>
                    <title>{t('terms-meta-title')}</title>
                    <meta name="title" content={t('terms-meta-title')} />
                    <meta name="description" content={t('terms-meta-description')} />
                    <meta name="keywords" content={t('terms-meta-keywords')} />
                </MetaTags>
                <div id="div-terms">
                    <div className="terms-header">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-12 col-md-10">
                                <div className="terms-header-text">{t('terms-title')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="terms-content">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-12 col-md-10">
                                <div className="terms-content-headline">{t('terms-headline-1')}</div>
                                <div className="terms-content-sub-content">{t('terms-content-sub-content-1-1')}<strong>{t('terms-content-sub-content-1-2')}</strong>{t('terms-content-sub-content-1-3')}<strong>{t('terms-content-keyword-2')}</strong>{t('terms-content-sub-content-1-4')}<strong>{t('terms-content-keyword-1')}</strong>{t('terms-content-sub-content-1-5')}</div>
                                <div className="terms-content-sub-headline">{t('terms-sub-headline-1')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-2-1')}</strong>{t('terms-content-sub-content-2-2')}<strong>{t('terms-content-keyword-1')}</strong>{t('terms-content-sub-content-2-3')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-3-1')}</strong>{t('terms-content-sub-content-3-2')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-4-1')}</strong>{t('terms-content-sub-content-4-2')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-5-1')}</strong>{t('terms-content-sub-content-5-2')}<strong>{t('terms-content-keyword-1')}</strong>{t('terms-content-sub-content-5-3')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-6-1')}</strong>{t('terms-content-sub-content-6-2')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-7-1')}</strong>{t('terms-content-sub-content-7-2')}<strong>{t('terms-content-keyword-1')}</strong>{t('terms-content-sub-content-7-3')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-8-1')}</strong>{t('terms-content-sub-content-8-2')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-9-1')}</strong>{t('terms-content-sub-content-9-2')}<strong>{t('terms-content-keyword-1')}</strong>{t('terms-content-sub-content-9-3')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-10-1')}</strong>{t('terms-content-sub-content-10-2')}<strong>{t('terms-content-keyword-2')}</strong>{t('terms-content-sub-content-10-3')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-11-1')}</strong>{t('terms-content-sub-content-11-2')}</div>
                                <div className="terms-content-sub-content"><strong>{t('terms-content-sub-content-12-1')}</strong>{t('terms-content-sub-content-12-2')}</div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    {/*  Modal */}
                    <div className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content bg-black">
                                <div className="modal-body">
                                    <div className="d-flex justify-content-end">
                                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>


                                    <p>{t('alert-msg-1')}</p>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Terms);



// WEBPACK FOOTER //
// ./src/components/pages/terms.js